// extracted by mini-css-extract-plugin
export default {"priceChangeHistoryContainer":"PriceChangeHistory_priceChangeHistoryContainer__TvuNV"};